module.exports = __webpack_public_path__ + "media/images/new_landing/logos/albatrosmedia-450128b1de304d80043a08d8520b2242.png";